import { render, staticRenderFns } from "./BarraTitulo.vue?vue&type=template&id=2a98ae1c"
import script from "./BarraTitulo.vue?vue&type=script&lang=js"
export * from "./BarraTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports